import React from 'react';
import {useItemContext} from 'shared/components/Accordion/Item';
import {MiniRadio} from 'shared/components/Forms/MiniRadio';
import styled, {useTheme} from 'styled-components';

interface ItemProps {
    children?: React.ReactNode;
}

export const Header = ({children}: ItemProps) => {
    const {isActive} = useItemContext();
    const theme = useTheme();

    return (
        <HeaderContainer $isActive={isActive}>
            <CustomRadio
                $checked={isActive}
                $round
                $coreColor={theme.colors.primary.main}
            />
            <ChildrenContainer>{children}</ChildrenContainer>
        </HeaderContainer>
    );
};

const ChildrenContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
`;

const HeaderContainer = styled.div<{$isActive: boolean}>`
    padding: 15px;
    background: #f7f7f7;
    cursor: pointer;
    font-weight: 400;
    font-size: 1em;
    display: flex;
    align-items: center;
    gap: 15px;

    ${({$isActive, theme}) => {
        if ($isActive) {
            return `
                border: 2px solid ${theme.colors.primary.main};
                color: ${theme.colors.primary.main};
                margin: -1px;
            `;
        }
    }}
`;

const CustomRadio = styled(MiniRadio)`
    padding-left: 15px;
    margin-top: -20px;
`;
